import { Injectable } from '@angular/core';

import {  doc, Firestore, getDoc, getDocsFromServer, limit, query, serverTimestamp,  updateDoc, increment, or } from '@angular/fire/firestore';
import { collection,getDocs,setDoc, where , orderBy } from '@firebase/firestore';
import * as _ from 'lodash';
import { reject } from 'lodash';
// import { getCountFromServer, collection } from 'firebase/firestore';
import { UserService } from './user.service';
import { HelperService } from './helper.service';
import { ProjectService } from './project.service';
import { WebsocketService } from './websocket.service';

@Injectable({
  providedIn: 'root'
})
export class InstancesService {
  leadGenList:any = []
  instanceRef:any
  isRegisterByEmail:boolean = false;
  constructor(private firestore: Firestore,
    private userService:UserService,
    private helperService: HelperService,
    private projectService:ProjectService,
    private wsService:WebsocketService
  ) {
    this.instanceRef = collection(this.firestore,'instances');
  }

  public setRegisteredPlayerByEmail(v : any) {
    this.isRegisterByEmail = v;
  }

  public getRegisteredPlayerByEmail() {
    return this.isRegisterByEmail;
  }

  getInstanceById(instanceId:any) {
    return new Promise((resolve, reject) => {
      const ref =doc(this.instanceRef,instanceId)
      getDoc(ref).then(doc => {
        let instanceDetails:any = null;
        instanceDetails = doc.data();
        if(doc && doc.id)instanceDetails.id = doc.id;
      
        resolve(instanceDetails)
      }).catch(err => {
        reject(err)
      });
    });
  }

  async updateRapidLeagueCategoryStats(data:any){ 
    const docRef1 = doc(this.firestore, 'rapid_quiz_league', 'leagueCategoryStats', 'players', data.playerId);
    await setDoc(docRef1, {playerId: data.playerId, playerName: data.playerName, playerEmail: data.playerEmail}, {merge: true});
    
    const docRef2 = doc(this.firestore, 'rapid_quiz_league', 'leagueCategoryStats', 'players', data.playerId, 'league', data.leagueId);
    await setDoc(docRef2, {
      [`${data.category}`]: {
        'totalQuestions': increment(1),
        'correctAnswers': data.isCorrect ? increment(1) : increment(0),
        'score': increment(data.score),
      },
    }, {merge:true}).then(()=>{
      console.log('updated');
    }).catch((err:any)=>{
      console.log('error updating league stats ', err)
    })
  }

  async getRapidLeagueCategoryStats(){
    let currentPlayerStat:any;
    const collectionRef = collection(this.firestore, 'rapid_quiz_league', 'leagueCategoryStats', 'players');
    const playersSnapshot = await getDocs(collectionRef);
    const players = playersSnapshot.docs.map(doc => doc.id);
    console.log('players ', players)

    const promises = players.map((playerId: any) => {
      const docRef = doc(this.firestore, 'rapid_quiz_league', 'leagueCategoryStats', 'players', playerId, 'league', 'dummyLeague');
      return getDoc(docRef).then((doc: any) => doc.exists() ? doc.data() : null);
    });

    Promise.all(promises).then((results) => {
      const stats = results.filter(data => data !== null);
      console.log('stats', stats);
      // set the actual player id here
      let playerId = 'deepak';

      let playersStats:any=[]
      let categoryStat:any={};
      stats.forEach((stat: any, index: any) => {
        Object.keys(stat).forEach(key => {
          if (key !== 'playerId') {
            console.log('key ', key)
            const score = stat[key]?.score || 0;

            if (!categoryStat[key]) {
              categoryStat[key] = {
                quintileList: [],
                totalScore: 0,
                topScore: score,
                meanScore: 0,
                quintileMean: 0,
                playerCounts: 0
              };
            }

            // Total Score
            if (categoryStat[key].totalScore !== undefined) {
              categoryStat[key].totalScore += score;
              categoryStat[key].playerCounts += 1;
            } else {
              categoryStat[key].totalScore = score;
              categoryStat[key].playerCounts += 1;
            }

            // Top Score
            if (categoryStat[key].topScore !== undefined) {
              if (categoryStat[key].topScore < score) {
                categoryStat[key].topScore = score;
              }
            } else {
              categoryStat[key].topScore = score;
            }

            categoryStat[key].quintileList.push(score);
            categoryStat[key].quintileList.sort((a: any, b: any) => a - b)
            if (categoryStat[key].quintileList.length > 20) {
              categoryStat[key].quintileList.length = 20;
            }
            const sumOfquintileList = categoryStat[key].quintileList.reduce((sum: any, value: any) => sum + value, 0);

            // Mean / Quintile Mean
            categoryStat[key].meanScore = Number((categoryStat[key].totalScore / categoryStat[key].playerCounts).toFixed(2));
            categoryStat[key].quintileMean = Number((sumOfquintileList / categoryStat[key].quintileList.length).toFixed(2));
          }
        });
      });

      stats.forEach((stat:any)=>{
        let playersStat = stat;
        playersStat.categoryStat = categoryStat

        if(playerId == playersStat.playerId){
          currentPlayerStat = playersStat;
        }

        playersStats.push(playersStat);
      })


      console.log('categoryStats ', categoryStat);
      console.log('playersStats ', playersStats); // can be used to download all player stats (in each document, use categoryStat object to show in table for each player)
      console.log('currentPlayerStat ', currentPlayerStat); // can be used to download individual player stat

      // sort the category sheet alphabetically (category name)
    });
  }

  endsWithRapidQuiz(str: any) {
    const regex = /RapidQuiz$/;
    return regex.test(str);
  }

  async createManualRapidLeagueCategoryStats() {
    const contentAccount = 'nF88qYA8CKeDWr7SUIl7s2k6K0F3';
    const quizId = '4ebae5b8-a7de-41b3-a843-ba845166678c';
    const questionCategoryHash: any = {};

    const instanceRef = collection(this.firestore, 'instances');
    const queryRef = query(instanceRef, where('quiz', '==', quizId), where('website', '==', 'rapidquizleague.com'), orderBy('totalTimeTaken', 'desc'));

    const docsSnap = await getDocs(queryRef);
    if (docsSnap) console.log('instance size ', docsSnap.size);

    const instanceRef2 = collection(this.firestore, 'rapid_quiz_league', 'leagueCategoryStats', 'players');
    const docsSnap2 = await getDocs(instanceRef2);
    if (docsSnap2) console.log('player stats size  ', docsSnap2.size);

    for (const docSnap of docsSnap.docs) {
      const instanceDetails:any = docSnap.data();
      if (!instanceDetails) continue;

      console.log('instanceDetails', instanceDetails);
      if(!instanceDetails.refPlayerId || !this.endsWithRapidQuiz(instanceDetails.refPlayerId))
        continue

      // let refplayerid = instanceDetails.refPlayerId;
      // if(refplayerid == '7022671b-6d69-4f5d-9e36-9ccd1aaa61b2RapidQuiz' || refplayerid == '5775168f-676d-4648-be60-52ff15259b74RapidQuiz' || refplayerid == 'd3cdcb99-73f3-4782-a2be-1cf0821c0bd2RapidQuiz' || refplayerid == 'c91b30da-2203-4dcc-9f8a-ff05ae872d2bRapidQuiz' || refplayerid == 'b80447e5-8a1e-4066-b6b8-520558c18a0eRapidQuiz' || refplayerid == 'a5533f66-ca6e-41f2-9a22-aacd7eb5dba0RapidQuiz' || refplayerid == '91398f98-047c-4448-a2ce-ddfd6a65eb85RapidQuiz' || refplayerid == 'b4085d4f-9024-4d5a-84c1-b2412c87bd78')
      //   continue


      const ansRef = collection(this.firestore, 'answers');
      const answerQueryRef = query(ansRef, where('instance', '==', instanceDetails.id));
      const answerDocsSnap = await getDocs(answerQueryRef);

      for (const adocSnap of answerDocsSnap.docs) {
        const answerDetails:any = adocSnap.data();
        if (!answerDetails) continue;

        // console.log('answer details ', answerDetails)
        let category: string;
        if (!questionCategoryHash[answerDetails.question]) {
          const qRef = doc(this.firestore, 'contentAccountMapping', contentAccount, 'quiz', quizId, 'question', answerDetails.question);
          const qDocSnap = await getDoc(qRef);
          const question:any = qDocSnap.data();

          if (!question || !question.questionCategory || !question.questionCategory.categoryDescription) {
            console.log('question not found:', answerDetails.question);
            continue;
          }

          category = question.questionCategory.categoryDescription;
          questionCategoryHash[answerDetails.question] = category;
        } else {
          category = questionCategoryHash[answerDetails.question];
        }

        // Player-level stats doc
        const playerDocRef = doc(this.firestore, 'rapid_quiz_league', 'leagueCategoryStats', 'players', instanceDetails.refPlayerId);
        await setDoc(playerDocRef, { playerId: instanceDetails.refPlayerId, playerName: instanceDetails.fullName, playerEmail: instanceDetails.email }, { merge: true });

        // League + category stats
        if(instanceDetails.leagueName){
          const leagueDocRef = doc(this.firestore, 'rapid_quiz_league', 'leagueCategoryStats', 'players', answerDetails.refPlayerId, 'league', 'Default-League');
          await setDoc(leagueDocRef, {
            [category]: {
              totalQuestions: increment(1),
              correctAnswers: answerDetails.correct ? increment(1) : increment(0),
              score: increment(answerDetails.points),
            },
          }, { merge: true }).then(() => {
            console.log('Updated stats for player:', answerDetails.refPlayerId);
          }).catch(err => {
            console.error('Error updating league stats:', err);
          });
        }
      }
    }
  }


  // getInstanceDetailsByRecipientId
  getInstanceDetailsByRecipientId(recipientId:any) {
    return new Promise((resolve, reject) => {
      let instanceDetails:any;
      let quizRef = collection(this.firestore, 'instances')
      let queryRef = query(quizRef, where('recipientId', '==', recipientId),where('completed', '==', true),limit(1))
      getDocs(queryRef).then(async (docs:any) => {
        await docs.forEach((doc:any) => {
          let data = doc.data()
          instanceDetails = data
          // console.log(instanceDetails)
        });
        resolve(instanceDetails)
      })
      .catch((err: any) => {
        console.log(err)
        reject(err)
      })
    })
  }

  // here we are creating instance for contest
  createInstanceForContest(contestDetail:any,data:any=null) {
    if(data){
      return new Promise((resolve, reject) => {
        let iId = data.id
        let docref:any = doc(this.firestore,'instances',iId)
        const createdOn = serverTimestamp();
        var newInstance = {
          ...data,
        };
        setDoc(docref,newInstance)
          .then((instance) => {
            resolve(newInstance)
          })
          .catch((error) => {
            reject(error)
          });
      })
    }else{
      return new Promise((resolve, reject) => {
        let instanceId = this.helperService.uuidv4()
        let docref:any = doc(this.firestore,'instances',instanceId)
        const createdOn = serverTimestamp();
        var newInstance = {
          // ...data,
          contestId:contestDetail.contestId,
          contestName:contestDetail.contestName,
          contestType:contestDetail.contestType,
          id: instanceId,
          viewed: true,
          started: false,
          completed: false,
          refContentId:contestDetail.contentId,
          refAccountId:contestDetail.accountId,
          viewedOn: createdOn,
          createdOn: createdOn,
          ManuallyAddedInLeaderBoard: false,
          mode:'link'
        };
        setDoc(docref,newInstance)
          .then((instance) => {
            resolve(newInstance)
          })
          .catch((error) => {
            reject(error)
          });
      })
    }
  }
  
  createInstance(data:any,playerId:any=null, projectId:any=null) {
    var contentRef = this.userService.getUserContentRef()
    return new Promise(async (resolve, reject) => {
      let instanceId
      if (contentRef.refAccountId === "nF88qYA8CKeDWr7SUIl7s2k6K0F3" && playerId) {
        instanceId = projectId + "___" + playerId
      } else {
        instanceId = this.helperService.uuidv4()
      }
      let exist: any = null
      let docref: any = doc(this.firestore, 'instances', instanceId)
      if (contentRef.refAccountId === "nF88qYA8CKeDWr7SUIl7s2k6K0F3" && playerId) {
        try {
            exist =  await this.getInstanceById(instanceId)
        } catch (error) {
          console.error("while getting insta cid ====>")
        }
      
      }
      console.log("exist ", exist)
      if (exist) {
        setDoc(docref, exist, { merge: true })
          .then((instance) => {
            resolve(exist)
          })
          .catch((error) => {
            reject(error)
          });



      } else {


        const createdOn = serverTimestamp();
        var newInstance = {
          ...data,
          id: instanceId,
          viewed: true,
          started: false,
          completed: false,
          refContentId: contentRef?.contentId ? contentRef.contentId : data.refContentId,
          refAccountId: contentRef?.refAccountId ? contentRef.refAccountId : data.refAccountId,
          viewedOn: createdOn,
          createdOn: createdOn,
          ManuallyAddedInLeaderBoard: false
        };
        // console.log("instance id ====>", instanceId)
        //  this.wsService.connect('ws://localhost:8080', instanceId);
        setDoc(docref, newInstance)
          .then((instance) => {
            resolve(newInstance)
          })
          .catch((error) => {
            reject(error)
          });

      }


    })
  }

  updateInstanceSinglePage(instanceId:any) {
    return new Promise((resolve, reject) => {
      let data:any = {
        takeMeHome:true,
        updatedOn:serverTimestamp()
      }
      let docRef = doc(this.instanceRef,instanceId)
      setDoc(docRef,data,{merge:true}).then(result => {
          resolve(result)
        }).catch(err => {
          reject(err)
        })
      })
    }  

  updateInstance(instanceId:any, data:any, para:any=null , drsUpdate:any=null) {
    return new Promise((resolve, reject) => {
      if(!data.isLiveQuizCompleted  && !drsUpdate){
        if(data.started && para!=null){
          data.startedOn =serverTimestamp()
        }
        if(data.completed)
          data.completedOn =serverTimestamp()
      }
      data.updatedOn =serverTimestamp()
      let docRef = doc(this.instanceRef,instanceId)
    setDoc(docRef,data,{merge:true}).then(result => {
        resolve(result)
      }).catch(err => {
        reject(err)
      })
    })
  }

  updateInstanceStats(instanceId:any, data:any , drsUpdate:any=null) {
    let docRef = doc(this.firestore,'instance_stats',instanceId)
    if(data.completed && !drsUpdate ) {
        data.completedOn=serverTimestamp()
    } 
    data.updatedOn=serverTimestamp()
    setDoc(docRef ,data, {merge:true});
  }

  updateInstanceCategoryStats(instanceId:any, data:any) {
    let docRef = doc(this.firestore,'instance_category_stats',instanceId)
    if(data.completed)
      data.completedOn=serverTimestamp()
    data.updatedOn=serverTimestamp()
    setDoc(docRef ,data, {merge:true});
  }

  getInstanceStatsByInstanceId(instanceId:any){
    return new Promise((resolve,reject)=>{
      let ref =doc(this.firestore,'instance_stats',instanceId)
      getDoc(ref).then(doc=>{
        let instance = doc.data()
        resolve(instance)
      }).catch(err=>{
        reject(err)
      })
    })
  }
  getInstanceCategoryStatsByInstanceId(instanceId:any){
    return new Promise((resolve,reject)=>{
      let ref =doc(this.firestore,'instance_category_stats',instanceId)
      getDoc(ref).then(doc=>{
        let instance = doc.data()
        resolve(instance)
      }).catch(err=>{
        reject(err)
      })
    })
  }

  getQuizStats(quizId:any) {
    return new Promise((resolve, reject) => {
      if(quizId){     
        let ref = doc(this.firestore,'quiz_stats',quizId)
        getDoc(ref).then(doc => {
          let data:any = null;
          data = doc.data();
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      }
    })
  }

  //update quiz_stats
  updateQuizStats(quizId:any,quizStatsObj:any) {
    return new Promise((resolve, reject) => {
      let docRef = doc(this.firestore,'quiz_stats',quizId)
      updateDoc(docRef,quizStatsObj)
        .then((result) => {
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getInstanceDetailsById(instanceId:any) {
    return new Promise((resolve, reject) => {
      let docRef = doc(this.firestore,'instances', instanceId);
      getDoc(docRef).then((doc) => {
        let instanceDetails:any;
        instanceDetails = doc.data();
        if(!instanceDetails.id)
          instanceDetails.id = doc.id;
        resolve(instanceDetails)
      }).catch(err => {
        reject(err)
      })
    })
  }

  //get top user score in instances collection
  public getInstanceDetailsByQuizId(quizId:any,key:any,value:any , allData:any=false) {
    return new Promise((resolve, reject) => {
      let data:any;
      let quizRef = collection(this.firestore, 'instances')
      let queryRef = query(quizRef, where('quiz', '==', quizId),orderBy(key,value), limit(1))
      getDocs(queryRef).then(async (docs:any) => {
        await docs.forEach((doc:any) => {
          if(allData)
            data = doc.data()
          else if(key === 'totalPoints')
            data = doc.data().totalPoints
          else if(key === 'createdOn')
            data = doc.data().startedOn
          else if(!doc.data().startedOn)
            data = doc.data().createdOn
        });
        resolve(data)
      })
      .catch((err: any) => {
        console.log(err)
        reject(err)
      })
    })
  }

  public getQuizDuration(instance:any) {
    if (!(instance && instance.startedOn && instance.completedOn)) {
      return '0 Seconds';
    }
    let startTime = instance.startedOn
    let completedTime = instance.completedOn
    //  console.log("startedOn:",startTime.seconds*1000,"completedOn:",completedTime.seconds*1000)
    let time = completedTime - startTime
    let seconds = Number(time);
    // let d = Math.floor(seconds / (3600*24));
    let h = Math.floor(seconds % (3600*24) / 3600);
    let m = Math.floor(seconds % 3600 / 60);
    let s = Math.floor(seconds % 60);
    // let dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
    let hDisplay = h > 0 ? h + (h == 1 ? " Hour, " : " Hours, ") : "";
    let mDisplay = m > 0 ? m + (m == 1 ? " Minute, " : " Minutes, ") : "";
    let sDisplay = s > 0 ? s + (s == 1 ? " Second" : " Seconds") : "";
    let totalTime = hDisplay+mDisplay+sDisplay
    return totalTime;
  }

  getInstanceDetails(instances:any){
    return new Promise((resolve, reject) => {
      let quizIds:any=[]
      let quizRef = collection(this.firestore, 'instances')
      let queryRef = query(quizRef, where('id', 'in', instances),where('completed','==',true),orderBy('createdOn'))
      getDocs(queryRef).then((docs:any) => {
        docs.forEach((result:any) => {
          quizIds.push(result.data().quiz)
        });
        resolve(quizIds)
      })
      .catch((err: any) => {
        console.log(err)
        reject(err)
      })
    })
  }
  getinstanceByplayerIdAndQuizId(quizId:any,playerId:any,refAccountId:any=null){
    return new Promise((resolve, reject) => {
      let instanceRef = collection(this.firestore, 'instances')
      let queryRef:any;
      //if get refAccountId then run this query otherwise run else part query
      if(refAccountId){
        queryRef = query(instanceRef, where('quiz', '==', quizId), where('refPlayerId', '==', playerId),where('refAccountId', '==', refAccountId),where('completed','==',true), limit(1))
      }else{
        queryRef = query(instanceRef, where('quiz', '==', quizId), where('refPlayerId', '==', playerId),where('completed','==',true), limit(1))
      }
      let instanceDetails:any
      getDocs(queryRef).then((querySnapshot: any) => {
        querySnapshot.forEach((doc:any) => {
          instanceDetails = doc.data();
        })
        if(instanceDetails) {
          resolve(instanceDetails)
        }
        else {
          resolve(false)
        }
      })
        .catch((err: any) => {
          console.log(err)
          resolve(false)
        })
    })
  }

  getCount(liveId:any){
    return new Promise(async (resolve, reject) => {
      let coll:any = collection(this.firestore, `liveQuiz/${liveId}/attendees`);
        const snapshot = await getDocsFromServer(coll);
        // console.log('count:=====>> ', snapshot , snapshot.size);
        if(snapshot.size){
          resolve(snapshot.size)
        }
    }).catch((err)=>{
      reject(err)
    })
    }

  // START===================question level answer data download============================
  //get top user score in instances collection 'createdOn','asc'
  public getInstanceDetailsByLiveQuizId(liveQuizId:any) {
    return new Promise((resolve, reject) => {
      let instanceDetails:any = [];
      let quizRef = collection(this.firestore, 'instances')
      let queryRef = query(quizRef, where('liveQuizId', '==', liveQuizId),where('viewed', '==', true))
      getDocs(queryRef).then(async (docs:any) => {
        await docs.forEach((doc:any) => {
          let data = doc.data()
          let data1 = {
            ...data,
            instanceId:data.id
          }
          if(data1.name || data1.nickName)
            instanceDetails.push(data1)
        });
        resolve(instanceDetails)
      })
      .catch((err: any) => {
        console.log(err)
        reject(err)
      })
    })
  }

   //get top user score in instances collection 'createdOn','asc'
  //  public _getInstanceDetailsByQuizIdForExcel(quizId:any) {
  //   // let instancesss = ["Urgn17kXQqSqlATSXxEr"]
  //   return new Promise((resolve, reject) => {
  //     let instanceDetails:any = [];
  //     let quizRef = collection(this.firestore, 'instances')
  //     let queryRef = query(quizRef, where('quiz', '==', quizId),where('completed', '==', true))
  //     getDocs(queryRef).then(async (docs:any) => {
  //       await docs.forEach((doc:any) => {
  //         let data = doc.data()
  //         // if(instancesss.includes(data.id)){
  //           let data1 = {
  //             ...data,
  //             instanceId:data.id
  //           }
  //           instanceDetails.push(data1)
  //         // }
  //         // if(data1.name || data1.nickName)
  //       });
  //       resolve(instanceDetails)
  //     })
  //     .catch((err: any) => {
  //       console.log(err)
  //       reject(err)
  //     })
  //   })
  // }

  // get all questions by projectId
  public async _getAllQuestionsByProjectId(quizId: any,refContentId:any=null) {
    return new Promise((resolve, reject) => {
      const questionsRef = query(collection(this.firestore,'contentAccountMapping', refContentId, 'quiz', quizId, 'question'),where('questionStatus','!=','t'),orderBy('questionStatus'), orderBy('creationDate'))
      let questions: any = [];
      getDocs(questionsRef).then((snapshot) => {
        snapshot.forEach((doc: any) => {
          var q = doc.data();
          q['questionId'] = doc.id;
          let data = {
            ...q,
            questionId:doc.id,
            questionText:q.questionText
          }
          questions.push(data);
        })
        questions =  _.orderBy(questions, ['sequence'],['asc']);
        resolve(questions)
      }).catch(err => {
        reject(err)
      })
    })
  }
  getAllAnswersOfAnInstance(instanceId:any){
    return new Promise((resolve, reject) => {
      let answers1:any=[]
      let queryRef = query(collection(this.firestore, 'answers'),where('instance', '==', instanceId))
      getDocs(queryRef).then((docs:any) => {
        docs.forEach((result:any) => {
          let answerDoc:any = result.data()
          answerDoc.id = result.id
          answers1.push(answerDoc)
        });
        resolve(answers1)
      })
      .catch((err: any) => {
        console.log(err)
        reject(err)
      })
    })
  }
  // END===================question level answer data download============================

  //checking already played quiz for our quiz website 42dots
  getMicroQuizInstanceByplayerIdAndQuizId(quizId:any,playerId:any,refAccountId:any=null){
    return new Promise((resolve, reject) => {
      let instanceRef = collection(this.firestore, 'instances')
      let queryRef:any;
      queryRef = query(instanceRef, where('quiz', '==', quizId), where('refPlayerId', '==', playerId),where('refAccountId', '==', refAccountId),where('started','==',true), limit(1))
      let instanceDetails:any
      getDocs(queryRef).then((querySnapshot: any) => {
        querySnapshot.forEach((doc:any) => {
          instanceDetails = doc.data();
        })
        if(instanceDetails) {
          resolve(instanceDetails)
        }
        else {
          resolve(false)
        }
      })
        .catch((err: any) => {
          console.log(err)
          resolve(false)
        })
    })
  }

  setLeadGenList(leads:any){
    this.leadGenList = leads
  }
  getLeadGenList(){
    return this.leadGenList
  }


  getinstanceByAccountId(refAccountId:any=null){
    return new Promise((resolve, reject) => {
      let instanceRef = collection(this.firestore, 'instances')
      let queryRef:any;
      //if get refAccountId then run this query otherwise run else part query
      queryRef = query(instanceRef,where('refAccountId', '==', refAccountId),where('completed','==',true),orderBy('subscriptionForm'))
      getDocs(queryRef).then((querySnapshot: any) => {
        let instanceDetails:any = [{}]
        querySnapshot.forEach(async (doc:any) => {
          let __data = doc.data().subscriptionForm;
          // console.log(__data,doc.data())
          this.projectService.getQuizDetailsByOnlyQuizId(doc.data().quiz).then((res:any)=>{
            let DData:any = {}
            DData = {
              Fullname:__data.firstName?__data.firstName:'-',
              Email:__data.email?__data.email:'-',
              Phone:__data.phoneNumber?__data.phoneNumber:'-',
              City:__data.city?__data.city:'-',
              state:__data.state?__data.state:'-',
              country:__data.country?__data.country:'-',
              quizName:res.quizName?res.quizName:'-',
              // creationDate:doc.data().completedOn?doc.data().completedOn:'-'
              creationDate:doc.data().completedOn?doc.data().completedOn:'-'
            }
            instanceDetails.push(DData)
          })
        })
        if(instanceDetails) {
          resolve(instanceDetails)
        }
        else {
          resolve([])
        }
      })
        .catch((err: any) => {
          console.log(err)
          resolve(false)
        })
    })
  }
}
